import { alphaNum } from 'vuelidate/lib/validators'
/**
 * Validates an IBAN against format definitions
 */
const validateIBAN = function (iban) {
  // initialize
  let valid = false
  // strip white-space chars
  iban = iban.replaceAll(/\s+/g, '')
  if (alphaNum(iban)) {
    // get country code
    const cc = iban.substring(0, 2)
    let regexp = '^DE\\d{20}$'
    if (cc !== 'DE') {
      regexp = '^[A-Za-z]{2}\\d{2}[\\dA-Za-z]{11,30}$'
    }

    const r = new RegExp(regexp, 'i')
    valid = r.test(iban)
  }
  return valid
}

export default {
  methods: {
    validateIBAN
  }
}
